export const DOCUMENT_ACCESS = {
    Internal: "Internal",
    Public: "Public",
} as const;
export type DOCUMENT_ACCESS_NAMES = typeof DOCUMENT_ACCESS[keyof typeof DOCUMENT_ACCESS];
export const DOCUMENT_ACCESS_OPTIONS: string[] = [...Object.values(DOCUMENT_ACCESS)];
